import { createReducer, on } from '@ngrx/store';
import { defaultUserListFilter } from '../types/user-list-filter';
import {
  fetchUserList,
  loadedUserList,
  failedUserList,
  updateUserListFilter,
  resetUserList,
  deleteUser,
} from './user-list.actions';
import {
  initialUserListState,
  UserListState,
  initialDataSource,
} from './user-list.state';
import { UserListInterface } from '../types/user-list';

export const userListReducer = createReducer(
  initialUserListState,
  on(fetchUserList, (state): UserListState => ({ ...state })),
  on(loadedUserList, (state, action): UserListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedUserList, (state): UserListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updateUserListFilter, (state, { filter }): UserListState => {
    return {
      ...state,
      filter: { ...state.filter, ...(filter ?? defaultUserListFilter) },
      dataSource: { ...state.dataSource },
    };
  }),
  on(deleteUser, (state, action): UserListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: {
        ...state.dataSource,
        rawData: state.dataSource.rawData?.filter(
          (user: UserListInterface) => user.user_id !== action.user_id
        ),
      },
    };
  }),
  on(resetUserList, (state): UserListState => {
    return {
      ...state,
      filter: { ...defaultUserListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
